module.exports = __webpack_public_path__ + "img/timeline_mainevent-10.ae989282.jpg";